/* eslint-disable no-bitwise, no-empty */
import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';
import differenceInHours from 'date-fns/differenceInHours';
import formatDate from 'date-fns/format';

const DAYS_IN_WEEK = 7;
const HOURS_IN_DAY = 24;

export const getHasNewNotifications = createSelector(
    (state) => resolveProp('notifications.fetchHasNewNotifications.data.hasNew', state),
    (hasNew = false) => hasNew,
);

const getDifferenceInHours = (date) => {
    const now = new Date();
    return Math.abs(differenceInHours(date, now));
};

export const getHumanReadableFormat = (distance, notificationDate, language) => {
    if (distance <= HOURS_IN_DAY) return language.today;
    if (distance <= HOURS_IN_DAY * 2) return language.yesterday;
    if (distance < HOURS_IN_DAY * DAYS_IN_WEEK)
        return `${Math.floor(distance / HOURS_IN_DAY)} ${language.days} ${language.ago}`;
    const numWeeks = Math.floor(distance / HOURS_IN_DAY / DAYS_IN_WEEK);
    if (numWeeks <= 8) {
        if (numWeeks < 2) return `${numWeeks} ${language.week} ${language.ago}`;
        return `${numWeeks} ${language.weeks} ${language.ago}`;
    }
    return formatDate(new Date(notificationDate), 'd MMM yyyy');
};

export const getNotifications = (language) =>
    createSelector(
        (state) => resolveProp('notifications.fetch.data', state),
        (notifications = []) =>
            notifications
                .filter((notification) => notification?.payload?.destinationUrl)
                .map((notification) => ({
                    description: notification?.payload?.description,
                    destinationUrl: notification.payload.destinationUrl,
                    friendlyDateCreated: getHumanReadableFormat(
                        getDifferenceInHours(new Date(notification.createdAt)),
                        notification.createdAt,
                        language,
                    ),
                    id: notification.id,
                    isSeen: !!notification?.seenAt,
                    title: notification?.payload?.title,
                    isExclusive: !!notification?.payload?.badge,
                    disclaimer: notification?.payload?.disclaimer,
                    badge: notification?.payload?.badge,
                })),
    );
